export const SessionPhase = {
    CREATED: "created",
    OPEN_LOBBY: "open_lobby",
    LOCKED_LOBBY: "locked_lobby",
    QUESTION_INTRO: "question_intro",
    ANSWERING: "answering",
    ANSWER_REVEAL: "answer_reveal",
    LEADERBOARD: "leaderboard",
    PODIUM: "podium",
    ENDED: "ended",
    ABORTED: "aborted",
};
export const QuestionType = {
    QUIZ_SINGLE: "quiz_single",
    QUIZ_MULTI: "quiz_multi",
    TRUE_FALSE: "true_false",
    TYPE_ANSWER: "type_answer",
    SLIDE: "slide",
};
export const ScoringMode = {
    CLASSIC: "classic",
    ACCURACY: "accuracy",
};
export const PointsMode = {
    STANDARD: "standard",
    DOUBLE: "double",
    NONE: "none",
};
//# sourceMappingURL=phases.js.map